import firebase from "firebase/app";
import "firebase/database";
import "firebase/storage";

const dbConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_REALTIME_DATABASE_URL,
  storageBucket: process.env.REACT_APP_FIREBASE_BUCKET_URL,
};

const miscellaneousConfig = {
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

export const appConfig = {
  ...dbConfig,
  ...miscellaneousConfig,
};

let app = firebase.initializeApp({
  ...dbConfig,
  ...miscellaneousConfig,
});

// App is ready here.

export const database = app.database();
export const storage = app.storage();
